import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getMandateMatches, getSuggestions, addMandateMatch, updateMandateMatch, removeMandateMatch } from '../api/mandateMatches';

export function useMandateMatches(mandateId: string) {
  return useQuery({
    queryKey: ['mandate-matches', mandateId],
    queryFn: () => getMandateMatches(mandateId),
    enabled: !!mandateId,
    staleTime: 0,
  });
}

export function useMandateSuggestions(mandateId: string, enabled: boolean) {
  return useQuery({
    queryKey: ['mandate-suggestions', mandateId],
    queryFn: () => getSuggestions(mandateId),
    enabled: enabled && !!mandateId,
    staleTime: 60_000,
  });
}

export function useAddMandateMatch(mandateId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: addMandateMatch,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['mandate-matches', mandateId] });
      qc.invalidateQueries({ queryKey: ['mandate-suggestions', mandateId] });
      qc.invalidateQueries({ queryKey: ['sale-mandates'] }); // match_count in Liste aktualisieren
    },
  });
}

export function useUpdateMandateMatch(mandateId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: { status?: string; notes?: string | null } }) =>
      updateMandateMatch(id, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['mandate-matches', mandateId] });
      qc.invalidateQueries({ queryKey: ['sale-mandates'] });
    },
  });
}

export function useRemoveMandateMatch(mandateId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: removeMandateMatch,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['mandate-matches', mandateId] });
      qc.invalidateQueries({ queryKey: ['mandate-suggestions', mandateId] });
      qc.invalidateQueries({ queryKey: ['sale-mandates'] }); // match_count in Liste aktualisieren
    },
  });
}
